import { render, staticRenderFns } from "./delivery-address-form.vue?vue&type=template&id=d2718516&"
import script from "./delivery-address-form.vue?vue&type=script&lang=js&"
export * from "./delivery-address-form.vue?vue&type=script&lang=js&"
import style0 from "./delivery-address-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2718516')) {
      api.createRecord('d2718516', component.options)
    } else {
      api.reload('d2718516', component.options)
    }
    module.hot.accept("./delivery-address-form.vue?vue&type=template&id=d2718516&", function () {
      api.rerender('d2718516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/delivery-selector/delivery-address-form.vue"
export default component.exports